import React from 'react';

export type ThemeModePreference = 'light' | 'dark' | 'system';
export type ThemeMode = 'light' | 'dark';

/** Cookie name used by server and client for theme preference. */
export const THEME_COOKIE_NAME = 'theme-mode';

/** Server provides resolved theme so SSR and first client paint match (avoids 'system' resolving to light on server, dark on client). */
export interface ThemeFromServer {
  preference: ThemeModePreference;
  resolved: ThemeMode;
}

export const ThemeFromServerContext = React.createContext<
  ThemeFromServer | undefined
>(undefined);
